import styled from 'styled-components';

import Flag from 'components/Flag';
import { mediaQueryLaptopMin, colorAccent } from 'styles';

export const Wrapper = styled.div`
  margin: 0 -16px 0 0;

  @media all and ${mediaQueryLaptopMin} {
    margin: 0 -24px 0 0;
  }
`;

export const OverflowWrapper = styled.div`
  overflow-x: auto;
  max-width: 100%;
  background-image: linear-gradient(to right, white, white),
    linear-gradient(to right, white, white),
    linear-gradient(to right, rgba(0, 0, 0, 0.4), rgba(255, 255, 255, 0)),
    linear-gradient(to left, rgba(0, 0, 0, 0.3), rgba(255, 255, 255, 0));

  background-size: 64px 100%, 20px 100%, 64px 100%, 20px 100%;
  background-attachment: local, local, scroll, scroll;
  background-position: left center, right center, left center, right center;
  background-repeat: no-repeat;

  @media all and ${mediaQueryLaptopMin} {
    background-size: 60px 100%, 0px 100%, 60px 100%, 0px 100%;
  }
`;

export const TableScroll = styled.div`
  position: relative;
  z-index: 1;
  max-height: 70vh;
  padding-right: 16px;
  min-width: 100%;

  @media all and ${mediaQueryLaptopMin} {
    padding-right: 24px;
    max-height: 80vh;
  }
`;

export const TABLE = styled.table`
  font-size: 12px;
  line-height: 16px;
  width: 100%;
  margin: auto;
  border-collapse: separate;
  border-spacing: 0;
`;

export const TD = styled.td`
  height: 48px;
  padding: 0 8px;
  text-align: right;
  background-color: ${({ bg }) => (bg ? 'transparent' : '#FBFBFB')};
  min-width: 64px;
  border: 1px solid rgba(228, 234, 244, 0.5);
  border-top: none;

  & a {
    font-size: 14px;
    color: ${colorAccent};
  }

  &:not(:first-child) {
    border-left: none;
  }

  &:first-child {
    background-color: #fff;
    text-align: center;
    position: sticky;
    left: 0;
    z-index: 2;
    width: 48px;
    top: auto;
    padding: 12px 8px 7px;
    height: 48px;
    min-width: 54px;
  }
`;

export const TR = styled.tr`
  height: 48px;
`;

export const FlagList = styled(Flag)`
  margin: 0 auto 2px;
  display: block;
  zoom: 0.505;
`;

export const THEAD = styled.thead`
  ${TD} {
    background: #fff;
    position: sticky;
    top: 0;
    text-align: center;
    border-top: 1px solid rgba(228, 234, 244, 0.5);
  }

  td:first-child {
    left: 0;
    z-index: 5;
  }
`;
